<template>
  <div class="flex flex-col gap-[24px] px-[20px] pt-[16px] mx-auto">
    <template v-for="(item, index) in updates" :key="index">
      <div
        class="content-stretch flex gap-[16px] items-start relative shrink-0 w-full cursor-pointer"
        :class="{
          'bg-[#554638] p-[12px] rounded-[8px]': isHighlighted(item),
        }"
        @click="navigate(item.slug, item.isExternalLink)"
      >
        <div
          class="basis-0 content-stretch flex flex-col gap-[8px] grow items-start min-h-px min-w-px relative shrink-0"
        >
          <!-- Tags -->
          <div class="content-stretch flex flex-wrap gap-[4px] items-start relative">
            <div
              v-if="isWithinNewPeriod(item)"
              class="bg-[#FED970] text-[#8C7D2B] rounded-[16px] items-center justify-center px-[12px] py-[4px] flex font-semibold text-[0.75rem] leading-[1rem] whitespace-nowrap"
            >
              New
            </div>
            <div
              v-for="(tag, tagIndex) in item.church_update_tags"
              :key="tagIndex"
              class="rounded-[16px] px-[8px] py-[4px] flex items-center justify-center font-semibold text-[0.75rem] leading-[1rem]"
              :style="setTagColor(tag.backgroundColor, tag.textColor, isHighlighted(item))"
            >
              {{ tag.name }}
            </div>
          </div>
          <!-- Title -->
          <h1
            class="text-[1rem] font-bold leading-[1.375rem] tracking-[-0.48px]"
            :class="isHighlighted(item) ? 'text-white' : 'text-[#2B2926]'"
          >
            {{ item.title }}
          </h1>
          <!-- Date -->
          <div class="flex items-center w-full">
            <p
              class="text-[0.75rem] leading-[1rem] font-normal tracking-[-0.12px] whitespace-pre"
              :class="isHighlighted(item) ? 'text-[#ECEBEB]' : 'text-[#63615E]'"
            >
              {{ formatDate(item.date) }}
            </p>
          </div>
        </div>
        <!-- thumbnail -->
        <div
          class="rounded-[8px] shrink-0 overflow-hidden aspect-[16/9] w-[104px]"
          :class="isHighlighted(item) ? 'bg-[#ECEBEB]' : 'bg-[#C3C2C1]'"
        >
          <img
            v-if="item.thumbnail?.url"
            :src="item.thumbnail.url"
            class="w-full h-full object-cover object-center"
            alt=""
          />
        </div>
      </div>
      <hr v-if="index !== updates.length - 1" class="border-[#C0C0C0] border-[0.5px]" />
    </template>
  </div>
</template>

<script>
import { isWithinNewPeriod } from '@/utils/church-updates';

export default {
  props: {
    updates: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    isWithinNewPeriod,
    isHighlighted(_item) {
      // Check if item should be highlighted with dark background
      // Customize based on tags, priority, or other criteria as needed
      return false;
    },
    setTagColor(backgroundColor, textColor, isHighlighted) {
      if (isHighlighted) {
        return {
          backgroundColor: backgroundColor || '#D5CFC8',
          color: textColor || '#6D5A48',
        };
      }
      return {
        backgroundColor: backgroundColor,
        color: textColor,
      };
    },
    formatDate(dateString) {
      if (!dateString) return '';

      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = date.toLocaleString('en-US', { month: 'short' });
      const year = date.getFullYear();

      return `${day} ${month} ${year}`;
    },
    navigate(slug, isExternalLink) {
      this.$emit('open-church-update', slug, isExternalLink);
    },
  },
};
</script>
<style scoped>
* {
  font-family: 'Inter';
}
</style>
